import { QueryOptions, queryOptions } from '@tanstack/react-query';
import { service } from '@maia/customer';

export type Customer = Awaited<ReturnType<(typeof service)['getCustomer']>>;

export function getCustomerOptions(
  guid: string,
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Customer>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['customers', 'customer', guid],
    queryFn: async () => await service.getCustomer(guid),
    initialData,
  });
}
